var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _ellipse, _path32, _rect, _polygon, _path33, _rect2, _path34, _path35, _path36, _path37, _path38, _path39, _circle, _path40, _path41, _path42, _g, _path43, _path44, _rect3, _ellipse2, _ellipse3, _ellipse4, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path45, _path46, _ellipse5, _ellipse6, _ellipse7, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g2, _g3, _path84, _path85, _path86, _path87, _circle20, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _circle21, _circle22, _path121, _circle23, _circle24, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignInIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    width: 1024.09,
    height: 784.98,
    viewBox: "0 0 1024.09 784.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4e272d34-4a95-491b-8eeb-ec3c2b1ff143-405",
    x1: 594.64,
    y1: 658.46,
    x2: 594.64,
    y2: 303.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dfe83c1b-cff5-4c37-a040-65f303183b02-406",
    x1: 711.17,
    y1: 565.71,
    x2: 711.17,
    y2: 302.34,
    gradientTransform: "translate(131.32 -162.61) rotate(15.07)",
    xlinkHref: "#4e272d34-4a95-491b-8eeb-ec3c2b1ff143-405"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b4eb3044-adbb-4263-a632-f34b940e5ebc-407",
    x1: 320.65,
    y1: 775.34,
    x2: 320.65,
    y2: 216.33,
    xlinkHref: "#4e272d34-4a95-491b-8eeb-ec3c2b1ff143-405"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "electric_car") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.75,176.94c-5.48,6.65-7.59,16-9.95,24.79-19,70.84-65.82,127.82-119.14,168.52-22.58,17.24-50.07,40.36-45.13,71.27,2.66,16.6,14.33,28.82,23,42.34,18.19,28.31,24.09,66.79,15.42,100.68-9.86,38.56-37.42,74.54-28.89,113.53,5.26,24,23.12,41.08,40.29,55.76q40.18,34.33,82.92,64.32c19.1,13.4,39.42,26.44,61.68,28.14,19.6,1.5,38.8-5.95,57.41-13.3,16.26-6.43,32.93-13.12,46.06-26,8.57-8.41,15.4-19.26,24.92-26.14,22.36-16.16,51.08-5.92,76.72,1,60.5,16.24,125.25,10.31,182.82-16.74,88.31-41.5,155.62-128.65,242-175.41,37.14-20.11,77.54-32.59,111.93-58.49a209.09,209.09,0,0,0,49.2-53.24c26-40.11,40.06-91.25,36-141.31s-26.81-98.3-62.54-126.56c-38.25-30.25-86.56-35.9-130.08-54.06C872.47,137.26,832.49,105,788,84.89A264.67,264.67,0,0,0,559.69,90C511.24,114.5,462.15,171.66,408.19,176,369.75,179,292.77,140.52,262.75,176.94Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M956.08,408.59s-14.56-49.45,2.73-85.84a78.1,78.1,0,0,0,6.32-49,131.35,131.35,0,0,0-6.94-23",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M969,227.76c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M987.09,261.32C983.8,266.41,965,275.2,965,275.2s.34-20.71,3.63-25.8a11,11,0,0,1,18.42,11.93Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M986.3,318.69c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,0,1,9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M975.93,362c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M942,276.37c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,1,0,942,276.37Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M930.51,327.13c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M926.11,378c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M969,227.76c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M987.09,261.32C983.8,266.41,965,275.2,965,275.2s.34-20.71,3.63-25.8a11,11,0,0,1,18.42,11.93Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M986.3,318.69c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,0,1,9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M975.93,362c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M942,276.37c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,1,0,942,276.37Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M930.51,327.13c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M926.11,378c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1017.08,487.59s-14.56-49.45,2.73-85.84a78.1,78.1,0,0,0,6.32-49,131.35,131.35,0,0,0-6.94-23",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1030,306.76c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.09,340.32c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.3,397.69c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,1,1,9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.93,441c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1003,355.37c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,0,0,1003,355.37Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M991.51,406.13c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M987.11,457c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1030,306.76c0,6.06-11,23.63-11,23.63s-11-17.57-11-23.63a11,11,0,1,1,21.94,0Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1048.09,340.32c-3.29,5.09-22.05,13.87-22.05,13.87s.34-20.71,3.63-25.8a11,11,0,1,1,18.42,11.93Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.3,397.69c-5.41,2.73-26,.84-26,.84s10.75-17.71,16.16-20.44a11,11,0,1,1,9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.93,441c-4.87,3.6-25.53,5.23-25.53,5.23s7.6-19.27,12.48-22.88a11,11,0,0,1,13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1003,355.37c4.35,4.22,24.6,8.6,24.6,8.6s-5-20.11-9.31-24.34A11,11,0,0,0,1003,355.37Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M991.51,406.13c5.41,2.73,26,.84,26,.84s-10.75-17.71-16.16-20.44a11,11,0,0,0-9.88,19.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M987.11,457c4.87,3.6,25.53,5.23,25.53,5.23s-7.6-19.27-12.48-22.88a11,11,0,1,0-13,17.64Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 620.17,
    cy: 573.77,
    rx: 494.14,
    ry: 79.54,
    transform: "translate(-140.71 1.38) rotate(-5.57)",
    fill: "#6c63ff",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1069.18,532.76c18.49-37.9,14.67-99.59,12.7-120.53-.43-4.58-.77-7.21-.77-7.21s-16.3-2.57-10.29-22.3c2.94-9.66-7.5-15-18.9-17.93a133.12,133.12,0,0,0-24.84-3.51l-157.89-9.75h0c-21.65-34.36-64.25-28.84-64.25-28.84s-38-3.95-64.94-4.36A72.51,72.51,0,0,0,726.64,309a44,44,0,0,0-9.06-4.13,25.67,25.67,0,0,0-22.68,4.25,12.06,12.06,0,0,0-3.69,4.29,11.75,11.75,0,0,0-.75,2.41,43.1,43.1,0,0,0-1,4.29,7.39,7.39,0,0,1-1,1.95c-1.08,1.53-2.94,2.68-3.18,4.53a3,3,0,0,0,0,.32,3.36,3.36,0,0,0-.39,1.14,4.11,4.11,0,0,0,.51,2.37c.06.12.13.23.2.34a28.22,28.22,0,0,0-3.23,6.2,10.35,10.35,0,0,0-1.07.67l-.3.22,0,.61-.17.13-.37,9.85.21.16a29.16,29.16,0,0,0,13.56,22.76c.13.63.25,1.27.37,1.94a52.86,52.86,0,0,1,.74,9.78l-.17,0c-4.7-2-12.74.94-19.65,4.37H586c17.46-22.46,38.82-39.88,38.82-39.88V327.83c-15.26-.76-149.32,63.64-178.71,77.86l-1.3.63L293.76,411c-27.36-.17-51.28,3.85-72,10.4A204.89,204.89,0,0,0,131.6,479c-17.84,19.58-25.66,35.76-25.66,35.76l.17,1.36-.17.35.24.21,4.07,32.12,2.8,22.1c-19.46,12.58,5.75,17.62,5.75,17.62,24,20.58,62.61,19.73,62.61,19.73,9.43,12.87,36.88,11.15,36.88,11.15H362.38a349.13,349.13,0,0,1,9-39.2c6.15,44.29,41.1,78.22,83.28,78.22a77.86,77.86,0,0,0,9.36-.57,77.86,77.86,0,0,0,9.36.57c42.67,0,77.93-34.73,83.48-79.76h7.05a157.16,157.16,0,0,1-6.83,29.59c129.51-37.74,370.52-55.75,370.52-55.75,1-9.5,2.1-18.68,3.29-27.49,9.93,24.65,32.44,41.86,58.64,41.86a59.18,59.18,0,0,0,7.12-.44,59.18,59.18,0,0,0,7.12.44c31.11,0,57-24.27,62.84-56.45a147.11,147.11,0,0,1,1.32,17.13c-1.11,5.46-2.08,8.95-2.21,9.44q1.17-2.14,2.22-4.38c0,.58,0,1.18,0,1.78-.24,1-.41,1.56-.46,1.75l.44-.82c0,.44,0,.87,0,1.31C1067.82,536.67,1068.35,535.23,1069.18,532.76Z",
    transform: "translate(-87.95 -61.51)",
    fill: "url(#4e272d34-4a95-491b-8eeb-ec3c2b1ff143-405)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 669.22,
    y: 335.07,
    width: 296.9,
    height: 119.77,
    fill: "#6f7d95"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "593.73 278.98 635.9 373.45 719.41 368.39 722.78 329.59 725.31 284.04 607.23 275.6 593.73 278.98",
    fill: "#4b5c7a"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M681.68,340.49s16-15.18,35.43-18.56,84.35,3.37,84.35,3.37l9.28,16L809,348.92Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 453.29,
    y: 327.48,
    width: 299.43,
    height: 87.72,
    fill: "#4b5c7a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M767,448.67c7.91-26.45-7.86-43.83-7.86-43.83L733,386.6a1.23,1.23,0,0,1-.08.18A34,34,0,0,1,725.81,373c-.08-.32-.15-.65-.23-1a28.14,28.14,0,0,0,6.2-6.35c4.26-2.61,6.16-6.81,6.88-11a54.86,54.86,0,0,0,6.49-13.13,23.33,23.33,0,0,0,.66-2.29,12,12,0,0,0,.66-4.49,12.28,12.28,0,0,0-1.66-4.8c-4.4-8-12.32-13.57-20.35-18.11a43.3,43.3,0,0,0-8.91-4.06,25.25,25.25,0,0,0-22.3,4.18,11.86,11.86,0,0,0-3.63,4.22,11.56,11.56,0,0,0-.74,2.37,42.39,42.39,0,0,0-.95,4.22,7.27,7.27,0,0,1-.94,1.91c-1.07,1.5-2.89,2.63-3.13,4.46a2.94,2.94,0,0,0,0,.32,3.3,3.3,0,0,0-.38,1.12,4,4,0,0,0,.5,2.33c.06.12.13.23.2.34a27.76,27.76,0,0,0-3.18,6.1,10.18,10.18,0,0,0-1.06.66l-.29.21,0,.6-.17.13-.37,9.69.2.16a28.67,28.67,0,0,0,13.33,22.39c.13.62.25,1.25.36,1.91a51.33,51.33,0,0,1,.72,10.57,3.59,3.59,0,0,1,0-.92c-7.23-3.27-23,5.77-29.35,9.77h0a12.05,12.05,0,0,0-2.67,1.73l-.11.08v0c-4.37,3.54-13,13.38-19.85,38.67-9.5,35.29-8.51,43.29-15.43,51.47s-13.79,65.81-13.79,65.81l13.93,3.75,1.78-5.72c16.56,15.1,62.93,22.37,62.93,22.37l1.42-4.41c7.11,2.56,19-1.33,19-1.33,17.38-6.14,23.89-21.72,36.5-42.27S767,448.67,767,448.67ZM696.9,555,729,455.43c2.91,15.46-9.93,39.81-11.07,55.73C717.22,521.4,705.3,541.75,696.9,555Z",
    transform: "translate(-87.95 -61.51)",
    fill: "url(#dfe83c1b-cff5-4c37-a040-65f303183b02-406)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M737.06,343.9s5.59,21.29-11,25-5.66-9.57-5.66-9.57l16-15.59Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#472727"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M667.7,394.64s-12.34,5-21.41,38.68-8.17,41.28-14.7,49.11-13.22,62.77-13.22,62.77l13.06,3.52L642.8,512l31.27-97Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#dde0e4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M667.7,394.64s-12.34,5-21.41,38.68-8.17,41.28-14.7,49.11-13.22,62.77-13.22,62.77l13.06,3.52L642.8,512l31.27-97Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M736.22,390.84s-51.66,26.26-44.1,9.13c3.74-8.46,3.6-17.23,2.51-24a51.26,51.26,0,0,0-3.25-11.62s35.12-27.78,33.06-5.1a43.4,43.4,0,0,0,1,14.58C728.48,385.86,736.22,390.84,736.22,390.84Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#db8b8b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M725.44,373.87a27,27,0,0,1-24,5,27.31,27.31,0,0,1-6.85-2.89,51.26,51.26,0,0,0-3.25-11.62s35.12-27.78,33.06-5.1A43.4,43.4,0,0,0,725.44,373.87Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 708.88,
    cy: 351.42,
    r: 27.04,
    transform: "translate(97.29 883.04) rotate(-74.93)",
    fill: "#db8b8b"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M695.3,338.23a6.45,6.45,0,0,1-9-2.37,3.88,3.88,0,0,1-.46-2.22c.23-1.74,1.95-2.82,3-4.26,1.63-2.33,1.32-5.52,2.5-8.11a11.4,11.4,0,0,1,3.42-4,23.51,23.51,0,0,1,20.95-4.08,39.94,39.94,0,0,1,8.34,3.83c7.52,4.29,14.93,9.54,19,17.17a11.72,11.72,0,0,1,1.54,4.57,13,13,0,0,1-.9,5.1,53.16,53.16,0,0,1-6.23,12.67,9.76,9.76,0,0,0-3.24-2.61,3.34,3.34,0,0,0-3.84.71c-.87,1.11-1.4,3.23-2.72,2.73-.86-.32-.85-1.51-.81-2.43.18-4-2-7.77-4.93-10.47s-6.56-4.48-10.14-6.23c-2.57-1.26-6-4.15-8.82-4.66C699.46,332.92,697.81,336.68,695.3,338.23Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M695.67,336.86a6.45,6.45,0,0,1-9-2.37,3.88,3.88,0,0,1-.46-2.22c.23-1.74,1.95-2.82,3-4.26,1.63-2.33,1.32-5.52,2.5-8.11a11.4,11.4,0,0,1,3.42-4,23.51,23.51,0,0,1,20.95-4.08,39.94,39.94,0,0,1,8.34,3.83c7.52,4.29,14.93,9.54,19,17.17a11.72,11.72,0,0,1,1.54,4.57,13,13,0,0,1-.9,5.1,53.16,53.16,0,0,1-6.23,12.67,9.76,9.76,0,0,0-3.24-2.61,3.34,3.34,0,0,0-3.84.71c-.87,1.11-1.4,3.23-2.72,2.73-.86-.32-.85-1.51-.81-2.43.18-4-2-7.77-4.93-10.47s-6.56-4.48-10.14-6.23c-2.57-1.26-6-4.15-8.82-4.66C699.83,331.54,698.18,335.31,695.67,336.86Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#472727"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M709.83,394.42s21.39-4.19,22.32-7.62l24.46,17.27s14.72,16.49,7.19,41.73c0,0-6.13,52.89-18.05,72.52s-18.77,45.06-35.1,51c0,0-15.7-10.12-20.88-10,0,0,26.59-38.53,27.73-53.7s13.29-38.43,10.63-53.15l-36,111.9s-58-9-63.88-28.25c0,0,5-7.51,4.07-15.12s21.88-64.86,21.88-64.86l10.92-59.7s21.6-15.09,30.2-11.17C695.28,385.21,693.72,392.66,709.83,394.42Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#dde0e4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.62,348h0c-5.28-7.2-15.35-1.29-17-.26l-2.59-.26c-2.26-2.46-9.19-9-15.7-4.19l-.28.21-.39,9.23.28.22a19.28,19.28,0,0,0,6.29,3.22,9.49,9.49,0,0,0,4.44.22,7.66,7.66,0,0,0,5.11-4l1.35.09,1-.19a7.61,7.61,0,0,0,3.6,5.14c4.47,2.53,11,0,11.27-.05l.34-.13,2.4-8.93Zm-3.39,8.12c-1.33.45-6.35,1.93-9.72,0a6.46,6.46,0,0,1-3-4.86l-.12-.73-2.19.45L697,350.9l-.21.42A6.49,6.49,0,0,1,692.4,355c-3.77.81-8.13-2.11-9.27-2.94l.33-7.8c5.66-3.81,11.9,2.37,13.7,4.39l.19.21,3.65.36.22-.15c.1-.06,9.17-6.15,14.34-1.25a6.69,6.69,0,0,1,.71.77Z",
    transform: "translate(-87.95 -61.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734,352.64,717,351.23l-1.4-.27.63-2.36a6.69,6.69,0,0,0-.71-.77l2.06.2,13.91,1.36Z",
    transform: "translate(-87.95 -61.51)"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M717.8,347.36h0c-5.28-7.2-15.35-1.29-17-.26l-2.59-.26c-2.26-2.46-9.19-9-15.7-4.19l-.28.21-.39,9.23.28.22a19.28,19.28,0,0,0,6.29,3.22,9.49,9.49,0,0,0,4.44.22,7.66,7.66,0,0,0,5.11-4l1.35.09,1-.19a7.61,7.61,0,0,0,3.6,5.14c4.47,2.53,11,0,11.27-.05l.34-.13,2.4-8.93Zm-3.39,8.12c-1.33.45-6.35,1.93-9.72,0a6.46,6.46,0,0,1-3-4.86l-.12-.73-2.19.45-2.17-.14-.21.42a6.49,6.49,0,0,1-4.37,3.72c-3.77.81-8.13-2.11-9.27-2.94l.33-7.8c5.66-3.81,11.9,2.37,13.7,4.39l.19.21,3.65.36.22-.15c.1-.06,9.17-6.15,14.34-1.25a6.69,6.69,0,0,1,.71.77Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#472727"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M734.16,352l-16.94-1.41-1.4-.27.63-2.36a6.69,6.69,0,0,0-.71-.77l2.06.2,13.91,1.36Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#472727"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 233.14,
    y: 395.8,
    width: 296.9,
    height: 119.77,
    fill: "#6f7d95"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.02,
    cy: 503.34,
    rx: 82.85,
    ry: 90.67,
    fill: "#4b5c7a"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.02,
    cy: 503.34,
    rx: 82.85,
    ry: 90.67,
    opacity: 0.05
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 387.43,
    cy: 503.34,
    rx: 82.85,
    ry: 90.67,
    fill: "#4b5c7a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.59,
    cy: 503.8,
    r: 36.82,
    opacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.59,
    cy: 503.8,
    r: 11.05,
    fill: "none",
    stroke: "#6f7d95",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 385.59,
    cy: 484.47,
    r: 2.76,
    fill: "#6f7d95"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 488.65,
    cy: 551.31,
    r: 2.76,
    transform: "translate(-328.01 381.57) rotate(-40)",
    fill: "#6f7d95"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 494.29,
    cy: 566.32,
    r: 2.76,
    transform: "translate(-237.21 893.24) rotate(-80)",
    fill: "#6f7d95"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.41,
    cy: 580.27,
    r: 2.76,
    transform: "translate(-312.93 259.44) rotate(-30)",
    fill: "#6f7d95"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.66,
    cy: 583.21,
    r: 2.76,
    transform: "translate(-326.31 764.51) rotate(-70)",
    fill: "#6f7d95"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.28,
    cy: 573.04,
    r: 2.76,
    transform: "translate(-256.31 129.79) rotate(-20)",
    fill: "#6f7d95"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.12,
    cy: 557.01,
    r: 2.76,
    transform: "translate(-341.28 613.74) rotate(-60)",
    fill: "#6f7d95"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.69,494.78a.05.05,0,0,1,0,0c-2.83,19.54-10.7,40.93-10.7,40.93q.08-2,.1-3.95c0-1.68,0-3.34,0-5-1-53.86-30.35-87.09-49.28-103A106.39,106.39,0,0,0,995,412.6h51.45s20.24,41.33,24.46,61.57C1072.13,479.85,1071.79,487.18,1070.69,494.78Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.69,494.78a.05.05,0,0,1,0,0c-2.83,19.54-10.7,40.93-10.7,40.93q.08-2,.1-3.95c0-1.68,0-3.34,0-5-1-53.86-30.35-87.09-49.28-103A106.39,106.39,0,0,0,995,412.6h51.45s20.24,41.33,24.46,61.57C1072.13,479.85,1071.79,487.18,1070.69,494.78Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 895.02,
    cy: 435.02,
    rx: 63.01,
    ry: 68.96,
    fill: "#4b5c7a"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 895.02,
    cy: 435.02,
    rx: 63.01,
    ry: 68.96,
    opacity: 0.05
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 909.02,
    cy: 435.02,
    rx: 63.01,
    ry: 68.96,
    fill: "#4b5c7a"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.62,
    cy: 435.37,
    r: 28,
    opacity: 0.05
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.62,
    cy: 435.37,
    r: 8.4,
    fill: "none",
    stroke: "#6f7d95",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 907.62,
    cy: 420.67,
    r: 2.1,
    fill: "#6f7d95"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 1007.07,
    cy: 486.23,
    r: 2.1,
    transform: "translate(-164.89 699.58) rotate(-40)",
    fill: "#6f7d95"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1011.35,
    cy: 497.64,
    r: 2.1,
    transform: "translate(257.7 1345.71) rotate(-80)",
    fill: "#6f7d95"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 1005.36,
    cy: 508.26,
    r: 2.1,
    transform: "translate(-207.39 509.27) rotate(-30)",
    fill: "#6f7d95"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 993.38,
    cy: 510.5,
    r: 2.1,
    transform: "translate(85.96 1207.86) rotate(-70)",
    fill: "#6f7d95"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 983.97,
    cy: 502.75,
    r: 2.1,
    transform: "translate(-200.57 305.35) rotate(-20)",
    fill: "#6f7d95"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 983.85,
    cy: 490.57,
    r: 2.1,
    transform: "translate(-20.87 1035.81) rotate(-60)",
    fill: "#6f7d95"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M121.62,574.13,114,514.24h90.25l46.39,41.33-22.77,53.14S136,593.53,121.62,574.13Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M250.67,555.57l-22.77,53.14S136,593.53,121.62,574.13l-.33-2.61-7-55.38-.07-.55-.17-1.34h90.25Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M624.33,330.37v19.4s-46.64,38-57.74,73.85a45.18,45.18,0,0,0-2.15,18.09C568.66,481.35,443,409.65,443,409.65l5.59-2.72C477.48,393,609.32,329.61,624.33,330.37Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#7597ce"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M730.61,424s43.68-21.46,50.69-37.34c.94-2.13,1.83-4.28,2.87-6.37,4.33-8.71,13.43-29.14,8.85-38.95-5.9-12.65,14.34,1.69,14.34,1.69L795.55,402.9l-28.68,16L729.76,424",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M730.61,424s43.68-21.46,50.69-37.34c.94-2.13,1.83-4.28,2.87-6.37,4.33-8.71,13.43-29.14,8.85-38.95-5.9-12.65,14.34,1.69,14.34,1.69L795.55,402.9l-28.68,16L729.76,424",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M250.67,555.57l-22.77,53.14S136,593.53,121.62,574.13l-.33-2.61c.37-.25.76-.51,1.17-.76,0,0,27.83,21.93,91.1,27,0,0,38-30.37-23.62-64.1,0,0-53.6,1.68-75.68-17.51l-.24-.2.17-.35q.22-.43.71-1.34h89.37Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M564.44,441.7C568.66,481.35,443,409.65,443,409.65l5.59-2.72c3.7,3.94,18.47,17.23,48,15.79,19-.93,47.85-.08,70.05.89A45.18,45.18,0,0,0,564.44,441.7Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M618,457.31V577.08H562.84c3.64-27.86,1.54-68.47-33.84-91.75a85.58,85.58,0,0,0-89.3-2.66c-23.19,13.24-49.12,40.16-65.6,94.41h-53V457.31Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1070.69,494.78a.05.05,0,0,1,0,0c-2.08,13.22-5.42,26.06-10.59,37q-1,2.21-2.18,4.31c.13-.49,1.08-3.91,2.18-9.29,5.36-26.2,14.53-98.7-46.91-102.84-.8-.05-1.59-.1-2.38-.13A106.39,106.39,0,0,0,995,412.6h51.45s20.24,41.33,24.46,61.57C1072.13,479.85,1071.79,487.18,1070.69,494.78Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.59,535.27c.8-2.89,29.3-107.13-44.73-112.12-75.07-5.06-84.35,51.45-92.78,128.21,0,0-237,17.71-364.38,54.83,0,0,30.58-83.8-27-121.7a85.58,85.58,0,0,0-89.3-2.66c-28.4,16.22-60.93,53-75.16,135.32H224.52s-27,1.69-36.27-11c0,0-38,.84-61.57-19.4,0,0-25.3-5.06-5.06-17.71,0,0,28.68,21.93,91.94,27,0,0,38-30.37-23.62-64.1,0,0-54,1.69-75.91-17.71,0,0,7.69-15.91,25.24-35.16a201.5,201.5,0,0,1,88.63-56.67,229.54,229.54,0,0,1,70.85-10.22l148.87-4.64S462,426.1,496.54,424.41s102.06,2.53,102.06,2.53l.67,0,138.92-6.29A88.38,88.38,0,0,0,750,418.15c20.14-5.47,58.34-22.06,51.45-68.39l218.46,13.5a130.92,130.92,0,0,1,24.43,3.45c11.22,2.88,21.48,8.14,18.59,17.64-5.9,19.4,10.12,21.93,10.12,21.93s.34,2.59.76,7.09C1075.81,434.59,1079.74,498.39,1059.59,535.27Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M391.53,442.55s-91.1.84-151,54h33.74s94.47-24.46,117.24-43.86Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M390.68,441.7s-91.1.84-151,54h33.74s94.47-24.46,117.24-43.86Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffec9f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M228.74,423.25v22.67L152,481.35l-11.88-1.43A201.5,201.5,0,0,1,228.74,423.25Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M227.89,422.41v22.67L151.14,480.5l-11.88-1.43A201.5,201.5,0,0,1,227.89,422.41Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffec9f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M336.7,525.21s-41.33,25.3-45.55,81h23.62s9.28-60.73,36.27-81Z",
    transform: "translate(-87.95 -61.51)",
    fill: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M336.7,525.21s-41.33,25.3-45.55,81h23.62s9.28-60.73,36.27-81Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M825.08,526.9,610.83,552.2S596.66,462,599.28,426.91l138.92-6.29A88.38,88.38,0,0,0,750,418.15v8.37l104.59-25.3S872.31,427.36,825.08,526.9Z",
    transform: "translate(-87.95 -61.51)",
    fill: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M825.08,526.9,610.83,552.2S596.66,462,599.28,426.91l138.92-6.29A88.38,88.38,0,0,0,750,418.15v8.37l104.59-25.3S872.31,427.36,825.08,526.9Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M801.46,325.3s45.55-5.9,65.79,32.9l-65.14-2.51Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ff4d52"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M864.09,371.8c-1.79,5.61-.44,11.78,9.93,16.05,8.63,3.56,18.75-.56,21.7-9.41,1.72-5.16.54-11-8.76-15.75S867.22,362,864.09,371.8Z",
    transform: "translate(-87.95 -61.51)",
    fill: "none"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M864.09,371.8c-1.79,5.61-.44,11.78,9.93,16.05,8.63,3.56,18.75-.56,21.7-9.41,1.72-5.16.54-11-8.76-15.75S867.22,362,864.09,371.8Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M115.63,526.88s54.06,28,92.86,17.4",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#ff4d52",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M117.54,542s34.93,26.94,105.53,20.68",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#ff4d52",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M119.15,554.69S153.8,584.76,225,575.23",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#ff4d52",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M864.64,353.67S836.46,378,810.74,389C810.74,389,849.8,395.95,864.64,353.67Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M566.1,425.28s133.72,12.63,184.32.82c0,0,2.7,1.79-13.41-5.43Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1073.82,413.37c-8.33-5.47-21.54-16.82-19.74-29.45.9-6.33-3.58-12.25-9.73-17.22,11.22,2.88,21.48,8.14,18.59,17.64-5.9,19.4,10.12,21.93,10.12,21.93S1073.39,408.87,1073.82,413.37Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M401.73,501.41c.08-3.34,0-6.81-.25-10,0-.61-.1-1.2-.16-1.78,1.88,1.42,3,2.5,3,2.5l-1.65-86.84-9.1-45.49c0-32.26-17.37-41.35-17.37-41.35s-9.1-4.14-11.58-9.92-24.46-18-24.47-18a62.19,62.19,0,0,1-.2-6.33c0-.55,0-1.12.05-1.69a27.3,27.3,0,0,0,9.47-34.68c1.22,0,2.21-.51,2.67-2.32,1.46-5.73.05-14.36-3.27-18.94a18.59,18.59,0,0,0-2.39-2.65,41,41,0,0,0-3.25-2.93c-2.84-2.36-6-4.84-9.52-4.64a14.25,14.25,0,0,0-5.63,2q-13.19,6.94-26.31,14c-3.23,1.75-6.56,3.59-8.82,6.73s-3.17,7.16-3.8,11.11a27.24,27.24,0,0,0-.37,8.13,10.51,10.51,0,0,0,3.19,6.48,7.14,7.14,0,0,0,1.23,1.17c1.78,1.3,4.07,1.62,5.93,2.67A27.3,27.3,0,0,0,306,279.41c0,.51-.07,1-.11,1.56-.11,1.43-.28,3-.5,4.59v0s-6.11-.16-15.21,12.24-28.95,14.06-28.95,14.06-7.44-3.31-15.71,33.91-10.75,62-6.62,66.16a22.56,22.56,0,0,0,5.86,3.66,71.81,71.81,0,0,0,22.33,7,2,2,0,0,0,.49.79l.59,7.21h0c.5,15.22,1.08,45.75-2,52.52-4.14,9.1.83,14.89.83,14.89l1-.07a7.59,7.59,0,0,0,.62.9l4-.27c-.29,17-1.07,40.58-3.13,45.76-3.31,8.27,0,53.76,0,53.76l-5.79,81.88s-3.17,42.74-.2,47.69c-1.62,8.89-4.53,25.83-3.93,30.05.83,5.79,19.85,14.06,19.85,14.06s22.33,5,33.08,3.31c5.62-.87,7.85-4.67,7.87-8,7.29,1.17,16.78,2.29,22.73,1.37,10.75-1.65,9.1-14.06,3.31-13.23S334,744.4,329.08,738.61c-2.5-2.92-4.58-8.14-6-12.61a4.62,4.62,0,0,0,2.72-1.45c2.48-4.14,6.62-42.18,6.62-42.18l10.75-66.16s5.79-32.26,10.75-39.7c3.75-5.62,8.44-47.56,10.51-67.76l.18,0,.06,0,.22-.71L368,498c1.66,2.93,5.84,4.38,10.71,5-.52,2.12-.95,3.85-1.2,4.84-1.24,5,16.84,13.23,21.2,9.1,1.83-1.73,2.78-8,3-14.86l.15,0ZM293.07,726.95c-.28,1.61-.56,3.29-.84,5-.63-2-1.13-3.8-1.47-5.13C291.58,726.85,292.35,726.89,293.07,726.95Z",
    transform: "translate(-87.95 -61.51)",
    fill: "url(#b4eb3044-adbb-4263-a632-f34b940e5ebc-407)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M320.8,709.71s3.19,14.34,8,19.91,11.15,16.72,16.72,15.93,7.17,11.15-3.19,12.74-31.86-3.19-31.86-3.19-18.32-8-19.11-13.54,4.78-34.25,4.78-34.25Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#53526b"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M320.8,709.71s3.19,14.34,8,19.91,11.15,16.72,16.72,15.93,7.17,11.15-3.19,12.74-31.86-3.19-31.86-3.19-18.32-8-19.11-13.54,4.78-34.25,4.78-34.25Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M291.33,716.08s3.19,14.34,8,19.91,11.15,16.72,16.72,15.93,7.17,11.15-3.19,12.74S281,761.48,281,761.48s-18.32-8-19.11-13.54,4.78-34.25,4.78-34.25Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#53526b"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M363.81,497.86s-6.37,68.49-11.15,75.66-10.35,38.23-10.35,38.23l-10.35,63.71s-4,36.64-6.37,40.62-31.93,2.27-31.93,2.27L312,507.42Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#5f5d7e"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M363.81,497.86s-6.37,68.49-11.15,75.66-10.35,38.23-10.35,38.23l-10.35,63.71s-4,36.64-6.37,40.62-31.93,2.27-31.93,2.27L312,507.42Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.05
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M376.55,465.21l-2.08,6.61-11.25,35.71-.22.68-.06,0c-1.51.34-33.39,7.67-40.27,9.92a9.73,9.73,0,0,0-1.09.41c-3.19,1.59-7.17,58.93-7.17,58.93s-2.39,54.16-4,58.14-8,86-11.95,83.62-32.65,0-32.65,0c-3.19-3.19,0-46.19,0-46.19l5.57-78.85s-3.19-43.8,0-51.77,3.19-61.32,3.19-61.32L339.8,471l6.3-1Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#5f5d7e"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M374.47,471.82l-11.25,35.71-.27.7c-1.51.34-33.39,7.67-40.27,9.92l-.69,0L339.8,471l.51-1.36,5.79.37Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.02
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M300.09,305.93s29.47,31.86,47.79,5.57l17.52,11.95-3.19,18.32,10.35,138.58s-27.08-.8-46.19,5.57a29.64,29.64,0,0,1-31.06-7.17L298.5,356.9l-7.17-37.43Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M300.09,303.54s29.47,31.86,47.79,5.57l17.52,11.95-3.19,18.32L372.57,478s-27.08-.8-46.19,5.57a29.64,29.64,0,0,1-31.06-7.17l3.19-121.85-7.17-37.43Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#53526b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "37ab880d-f64d-47ff-bc41-44a88d46e9d6",
    "data-name": "TESLA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "738c7584-cfdc-46df-a1d6-157774876219",
    "data-name": "g8"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "1360335b-f9b9-41f4-b547-721f530fb53c",
    "data-name": "polyline10",
    points: "270.96 383.91 270.96 388.92 272.57 388.92 272.57 385.58 278.42 385.58 278.42 388.92 280.03 388.92 280.03 383.92 270.96 383.91",
    fill: "#e82127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "37b4067c-1094-4318-a4b4-d5befe986a46-408",
    "data-name": "path12",
    d: "M360.35,443.8h6.18a2.28,2.28,0,0,0,1.68-1.66h-9.53a2.29,2.29,0,0,0,1.68,1.66",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b91f5cfc-1188-4bfc-a136-ce6baaf8b578",
    "data-name": "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "9b1d3f19-25bc-4746-b3d7-b512ea849071-409",
    "data-name": "path16",
    d: "M354.05,450.43a2.3,2.3,0,0,0,1.41-1.63h-7.21v-6.66h-1.62v8.29h7.41",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f0b6def0-0db1-4d42-9c72-3add6bcfec75",
    "data-name": "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "59d3ad5d-2751-4b97-aa01-2f0d04d81291-410",
    "data-name": "path20",
    d: "M334.63,443.77h5.71a2.5,2.5,0,0,0,1.76-1.63H333V447h7.42v1.72h-5.82a3.25,3.25,0,0,0-2.07,1.68H342v-5h-7.41v-1.64",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f5aa069e-af4a-4185-a9be-44f8314aa55d",
    "data-name": "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "8469b87d-9cfc-4cf5-b98a-e8d4cd900d09-411",
    "data-name": "path24",
    d: "M320.54,443.79h6.18a2.28,2.28,0,0,0,1.68-1.66h-9.53a2.29,2.29,0,0,0,1.68,1.66",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "84ef8e86-997e-480d-b1fa-ac0f245eaf0f-412",
    "data-name": "path26",
    d: "M320.54,447.06h6.18a2.27,2.27,0,0,0,1.68-1.66h-9.53a2.29,2.29,0,0,0,1.68,1.66",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dccfde93-1eb8-4437-b458-7de4f8c559a0-413",
    "data-name": "path28",
    d: "M320.54,450.43h6.18a2.28,2.28,0,0,0,1.68-1.66h-9.53a2.29,2.29,0,0,0,1.68,1.66",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a108f4b8-96c8-4218-b56b-5c89101c02c8",
    "data-name": "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b75889ef-9b37-4c0c-a9df-261161e8d369-414",
    "data-name": "path32",
    d: "M304.47,442.15a2.31,2.31,0,0,0,1.67,1.65h2.6l.13.05v6.56h1.62v-6.56l.15-.05h2.6a2.34,2.34,0,0,0,1.67-1.65v0H304.47v0",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "2bbf1d6e-b78e-4014-bfd9-2e859831827e",
    "data-name": "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "838b4d4a-faf1-4893-a58e-72a43d116e4d-415",
    "data-name": "path35",
    d: "M336.34,425.75l8.11-45.63c7.73,0,10.17.85,10.53,4.31,0,0,5.19-1.93,7.8-5.86a57.34,57.34,0,0,0-20.47-4.95l-6,7.29h0l-6-7.29a57.33,57.33,0,0,0-20.47,4.95c2.61,3.93,7.8,5.86,7.8,5.86.35-3.46,2.79-4.31,10.47-4.32l8.18,45.64",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  }), /*#__PURE__*/React.createElement("path", {
    id: "4f686364-9558-435c-bd24-bcbef2ccf88c-416",
    "data-name": "path37",
    d: "M336.34,371.51A66.85,66.85,0,0,1,363.71,377a22.23,22.23,0,0,0,1.63-3.36,77.24,77.24,0,0,0-58,0A28.06,28.06,0,0,0,309,377a66.85,66.85,0,0,1,27.37-5.49h0",
    transform: "translate(-87.95 -61.51)",
    fill: "#e82127"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M361.42,468.39s0,20.71,4.78,29.47,32.65,4,32.65,4l-5.57-29.47Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#d39999"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M395.82,516.18c-4.2,4-21.61-4-20.41-8.76.84-3.37,3.78-15.43,5.45-22.27l1.16-4.81s10.2-3.19,13.8,0c1.31,1.16,2.23,5.73,2.66,11.25C399.22,501.18,398.49,513.65,395.82,516.18Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#fdc2cc"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M357.43,317.87l-27.87,21.5s-41.41-2.39-31.06-22.3a74.24,74.24,0,0,0,8-28.14,58.84,58.84,0,0,0,0-10.89s38.23-35,33.45,4.78a90.24,90.24,0,0,0-.66,9.2C338.76,321.88,357.43,317.87,357.43,317.87Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#fdc2cc"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.91,282.83a90.24,90.24,0,0,0-.66,9.2,26.1,26.1,0,0,1-14.47,4.34c-7.13,0-12.38-6.94-17.12-11.55.53-6.61-1.19-6.77-1.19-6.77S344.69,243,339.91,282.83Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.83,
    cy: 206.98,
    r: 26.28,
    fill: "#fdc2cc"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M306.07,293.58s-4.38.4-13.14,12.34S265,319.46,265,319.46s-7.17-3.19-15.13,32.65-10.35,59.73-6.37,63.71,19.91,9.56,27.87,9.56c0,0,2.39,50.17-1.59,58.93s.8,14.34.8,14.34l35-2.39s11.95-15.13,14.34-41.41,10.35-101.15,6.37-109.91-21.5-31.06-20.71-33.45S306.07,293.58,306.07,293.58Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M306,293.34s-5.89-.16-14.65,11.79-27.87,13.54-27.87,13.54-7.17-3.19-15.13,32.65S238,411.05,242,415s19.91,9.56,27.87,9.56c0,0,2.39,50.17-1.59,58.93s.8,14.34.8,14.34l35-2.39s11.95-15.13,14.34-41.41,10.35-101.15,6.37-109.91-21.5-31.06-20.71-33.45S306,293.34,306,293.34Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#d39999"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M285,395.92s39.85-45.7,34.25-14.34c-4,22.3-19.11,34.25-26.28,36.64S285,395.92,285,395.92Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#fdc2cc"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M398.48,491.59c-3.81-2.91-11-7.44-17.62-6.44l1.16-4.81s10.2-3.19,13.8,0C397.14,481.5,398.05,486.07,398.48,491.59Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M339.51,298.36s20.31,13.14,22.7,18.72,11.15,9.56,11.15,9.56,16.72,8.76,16.72,39.82l8.76,43.8L359,466s-4.78-55.75-7.17-69.29-5.57-39-5.57-39-11.95-15.13-10.35-19.11S339.51,298.36,339.51,298.36Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M339.44,298.12s21.18,11.79,23.56,17.36S374.16,325,374.16,325s16.72,8.76,16.72,39.82l8.76,43.8,1.59,83.62s-14.34-13.54-24.69-7.17-16.72-20.71-16.72-20.71-4.78-55.75-7.17-69.29-5.57-39-5.57-39S335.13,341,336.73,337,339.44,298.12,339.44,298.12Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#d39999"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M347.85,236.53a26,26,0,0,0-4.64-4.58c-2.74-2.28-5.77-4.66-9.17-4.46a13.72,13.72,0,0,0-5.42,1.94q-12.7,6.69-25.33,13.52c-3.11,1.68-6.32,3.46-8.49,6.48s-3.05,6.9-3.66,10.7a26.23,26.23,0,0,0-.36,7.82,9.81,9.81,0,0,0,3.46,6.57c2.27,1.65,5.38,1.66,7.28,3.82,1.1,1.25,1.58,3,2.36,4.52s2.13,3,3.67,2.73,2.47-1.9,2.69-3.55a21.55,21.55,0,0,0-.29-5c-.3-3,.08-6.18,1.82-8.41,1.2-1.52,2.92-2.44,4.08-4,2.78-3.76,1.51-10,4.56-13.53a7.23,7.23,0,0,1,7-2c2.47.52,4.73,1.86,7,3a52,52,0,0,0,9.59,3.7c2.78.76,6,2.58,6.95-1.12C352.4,249.25,351,240.94,347.85,236.53Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M347.05,235.73a26,26,0,0,0-4.64-4.58c-2.74-2.28-5.77-4.66-9.17-4.46a13.72,13.72,0,0,0-5.42,1.94c-8.46,4.46-15.49.24-25.33,13.52-2.1,2.84-6.32,3.46-8.49,6.48s-3.05,6.9-3.66,10.7a26.23,26.23,0,0,0-.36,7.82,9.81,9.81,0,0,0,3.46,6.57c2.27,1.65,5.38,1.66,7.28,3.82,1.1,1.25,1.58,3,2.36,4.52s2.13,3,3.67,2.73,2.47-1.9,2.69-3.55a21.55,21.55,0,0,0-.29-5c-.3-3,.08-6.18,1.82-8.41,1.2-1.52,2.92-2.44,4.08-4,2.78-3.76,1.51-10,4.56-13.53a7.23,7.23,0,0,1,7-2c2.47.52,4.73,1.86,7,3a52,52,0,0,0,9.59,3.7c2.78.76,6,2.58,6.95-1.12C351.61,248.45,350.25,240.14,347.05,235.73Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#865a61"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M275.4,353.71s-.8,29.47-4.78,33.45,2.39,8.76,2.39,8.76l15.93-4s-4,26.28,12.74,23.1c0,0-11.15,10.35-22.3,11.95S269,424.59,269,424.59l-16.72-19.91Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#d39999"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M275.27,357.29s-10.62,27.08-2.65,38.23l17.52-4s-15.93,4.78-13.54-4.78S275.27,357.29,275.27,357.29Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M269.43,424.19s23.1,1.59,29.47-3.19A61,61,0,0,1,270.15,433Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M369,373.22s11.95,36.64,11.15,42.21-2.39,66.9-2.39,66.9l-2.39-.8.8-66.9Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M872.12,476.83s17.5,34.35,3.24,53.14,1.3,70,1.3,70",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M877.3,466.14c0,6.62-4.86,12-4.86,12s-4.86-5.37-4.86-12,4.86-12,4.86-12S877.3,459.52,877.3,466.14Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M881.19,476.83s-17.5,34.35-3.24,53.14-1.3,70-1.3,70",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M876,466.14c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S876,459.52,876,466.14Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M876,466.14c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S876,459.52,876,466.14Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M888.32,476.83s17.5,34.35,3.24,53.14,1.3,70,1.3,70",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M893.5,466.14c0,6.62-4.86,12-4.86,12s-4.86-5.37-4.86-12,4.86-12,4.86-12S893.5,459.52,893.5,466.14Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M890.78,493.66c-4.59,4.77-11.82,5.27-11.82,5.27s.22-7.24,4.81-12,11.82-5.27,11.82-5.27S895.37,488.89,890.78,493.66Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M891.23,517.36c-4.59,4.77-11.82,5.27-11.82,5.27s.22-7.24,4.81-12S896,505.35,896,505.35,895.82,512.58,891.23,517.36Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M866.34,530.39c4.34,5,4.19,12.24,4.19,12.24s-7.19-.87-11.53-5.87-4.19-12.24-4.19-12.24S862,525.39,866.34,530.39Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M870.37,479.86c5.52,3.66,7.31,10.68,7.31,10.68S870.51,491.62,865,488s-7.31-10.68-7.31-10.68S864.85,476.2,870.37,479.86Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M870.37,479.86c5.52,3.66,7.31,10.68,7.31,10.68S870.51,491.62,865,488s-7.31-10.68-7.31-10.68S864.85,476.2,870.37,479.86Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M897.39,476.83s-17.5,34.35-3.24,53.14-1.3,70-1.3,70",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M892.21,466.14c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S892.21,459.52,892.21,466.14Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M892.21,466.14c0,6.62,4.86,12,4.86,12s4.86-5.37,4.86-12-4.86-12-4.86-12S892.21,459.52,892.21,466.14Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M893.61,494.17c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S898.25,489.45,893.61,494.17Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M893.61,494.17c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S898.25,489.45,893.61,494.17Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M902.72,527c-4.65,4.72-5,12-5,12s7.23-.41,11.88-5.13,5-12,5-12S907.37,522.26,902.72,527Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M889.31,519.77s10.53-16.6,25.32-17",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M881.11,509.74s-10.53-16.6-25.32-17",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M879.74,533.44s10.53-16.6,25.32-17",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 826.19,
    cy: 441.17,
    r: 2.73,
    fill: "#6c63ff"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 768.09,
    cy: 431.37,
    r: 2.73,
    fill: "#6c63ff"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M887.49,538.91s-10.53-16.6-25.32-17",
    transform: "translate(-87.95 -61.51)",
    fill: "none",
    stroke: "#6c63ff",
    strokeMiterlimit: 10
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 774.47,
    cy: 460.54,
    r: 2.73,
    fill: "#6c63ff"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 817.31,
    cy: 455.07,
    r: 2.73,
    fill: "#6c63ff"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M945.71,580s-25.38-5.08-32.15-11.85S876.33,549.57,872.95,558,827.26,595.26,856,600.33s67.69,6.77,76.15,3.38S945.71,580,945.71,580Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#a8a8a8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M856,597.19c28.77,5.08,67.69,6.77,76.15,3.38,6.44-2.58,10.92-15,12.69-20.72l.85.18s-5.08,20.31-13.54,23.69-47.38,1.69-76.15-3.38c-8.3-1.47-10.68-4.91-9.78-9.26C846.95,593.91,849.84,596.1,856,597.19Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M201.27,664.66s8.38,11-3.87,27.5S175.05,722.67,179.14,733c0,0,18.48-30.73,33.52-31.16S217.81,683.14,201.27,664.66Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M201.27,664.66a13.57,13.57,0,0,1,1.71,3.44c14.68,17.24,22.49,33.33,8.39,33.74-13.14.38-28.9,23.87-32.68,29.81a12.74,12.74,0,0,0,.45,1.35s18.48-30.73,33.52-31.16S217.81,683.14,201.27,664.66Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M216.85,678.62c0,3.86-.43,7-1,7s-1-3.13-1-7,.54-2,1.07-2S216.85,674.77,216.85,678.62Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffd037"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M222.19,683.23c-3.39,1.85-6.34,3-6.59,2.49s2.28-2.35,5.67-4.19,2.05-.5,2.31,0S225.58,681.38,222.19,683.23Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffd037"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M157,664.66s-8.38,11,3.87,27.5,22.35,30.51,18.26,40.83c0,0-18.48-30.73-33.52-31.16S140.46,683.14,157,664.66Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#6c63ff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M157,664.66a13.57,13.57,0,0,0-1.71,3.44c-14.68,17.24-22.49,33.33-8.39,33.74,13.14.38,28.9,23.87,32.68,29.81a12.74,12.74,0,0,1-.45,1.35s-18.48-30.73-33.52-31.16S140.46,683.14,157,664.66Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M141.42,678.62c0,3.86.43,7,1,7s1-3.13,1-7-.54-2-1.07-2S141.42,674.77,141.42,678.62Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffd037"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M136.08,683.23c3.39,1.85,6.34,3,6.59,2.49s-2.28-2.35-5.67-4.19-2.05-.5-2.31,0S132.69,681.38,136.08,683.23Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#ffd037"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M144.09,731.55s23.43-.72,30.49-5.75,36-11,37.79-3,35.21,40.11,8.76,40.32-61.46-4.12-68.51-8.41S144.09,731.55,144.09,731.55Z",
    transform: "translate(-87.95 -61.51)",
    fill: "#a8a8a8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M221.61,760.35c-26.45.21-61.46-4.12-68.51-8.41-5.37-3.27-7.51-15-8.22-20.41l-.78,0s1.48,18.9,8.53,23.19,42.06,8.63,68.51,8.41c7.64-.06,10.27-2.78,10.13-6.8C230.2,758.79,227.29,760.3,221.61,760.35Z",
    transform: "translate(-87.95 -61.51)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIllustration);
export default __webpack_public_path__ + "static/media/sign-in-illustration.1ee19b859190b6d56198998ee92ec921.svg";
export { ForwardRef as ReactComponent };